export const STEP_MS = 1_000 / 60;
export const MAX_FRAME_DELTA_MS = 250;
export const MAX_CATCHUP_STEPS = 5;

export class FixedStepDriver {
  private accumulatorMs = 0;
  public advance(deltaMs: number, step: () => void): number {
    const safeDelta = Number.isFinite(deltaMs) ? Math.max(0, Math.min(deltaMs, MAX_FRAME_DELTA_MS)) : 0;
    this.accumulatorMs += safeDelta;
    let count = 0;
    while (this.accumulatorMs >= STEP_MS && count < MAX_CATCHUP_STEPS) {
      step(); this.accumulatorMs -= STEP_MS; count += 1;
    }
    if (count === MAX_CATCHUP_STEPS && this.accumulatorMs >= STEP_MS) this.accumulatorMs = 0;
    return count;
  }
  public reset(): void { this.accumulatorMs = 0; }
}
